import { FIELD_TYPE_REGISTRY } from "./registryMetadata";
import { getDefinitionForType } from "./resolve";

const cloneDefaultValue = (value) => {
  if (Array.isArray(value)) return value.map((item) => cloneDefaultValue(item));
  if (value && typeof value === "object") return { ...value };
  return value;
};

export const getDefaultValueForType = (typeOrClass) => {
  const def = getDefinitionForType(typeOrClass);
  return cloneDefaultValue(def.defaultValue);
};

export const getEditableTypeKeys = () =>
  Object.values(FIELD_TYPE_REGISTRY)
    .filter((entry) => entry.capabilities?.editableInApp !== false)
    .map((entry) => entry.key);

export const getImportableTypeKeys = () =>
  Object.values(FIELD_TYPE_REGISTRY)
    .filter((entry) => entry.capabilities?.importable !== false)
    .map((entry) => entry.key);

export const buildTypeOptions = (allowedKeys) => {
  const keys =
    Array.isArray(allowedKeys) && allowedKeys.length
      ? allowedKeys
      : Object.keys(FIELD_TYPE_REGISTRY);

  return keys
    .map((key) => FIELD_TYPE_REGISTRY[key])
    .filter(Boolean)
    .map((entry) => ({
      key: entry.key,
      label: entry.label,
      icon: entry.iconEmoji,
    }));
};

export const filterImportFieldTypeOptions = (query = "") => {
  const options = buildTypeOptions(getImportableTypeKeys());
  const normalized = String(query).trim().toLowerCase();
  if (!normalized) return options;

  return options.filter(
    (option) =>
      option.label.toLowerCase().includes(normalized) ||
      option.key.toLowerCase().includes(normalized)
  );
};

export const resolveImportFieldTypeFromInput = (input) => {
  const trimmed = String(input || "").trim();
  if (!trimmed) return null;

  const upper = trimmed.toUpperCase();
  const importable = getImportableTypeKeys();
  if (importable.includes(upper)) return upper;

  const options = buildTypeOptions(importable);
  const byLabel = options.find(
    (option) => option.label.toLowerCase() === trimmed.toLowerCase()
  );
  return byLabel?.key || null;
};
